/** Lockup horizontal oficial (símbolo + wordmark), para usar sobre fondos claros. */
export function Marca({ className = 'h-20' }: { className?: string }) {
  return (
    <img
      src="/svg/cien-eventos_horizontal_claro.svg"
      alt="CIEN eventos"
      className={`mx-auto w-auto ${className}`}
    />
  );
}

/** Símbolo de marca (blanco + dorado) para usar sobre fondos oscuros (sidebar, nav móvil). */
export function SimboloMarcaBlanco({ className = 'h-8 w-8' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" aria-hidden="true">
      <circle cx="50" cy="50" r="26" fill="none" stroke="#FFFFFF" strokeWidth="10" />
      <rect x="37" y="5" width="26" height="10" rx="2" fill="#C39342" />
      <rect x="37" y="85" width="26" height="10" rx="2" fill="#FFFFFF" />
      <rect x="5" y="37" width="10" height="26" rx="2" fill="#FFFFFF" />
      <rect x="85" y="37" width="10" height="26" rx="2" fill="#FFFFFF" />
    </svg>
  );
}
